var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavbarMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.5L8.05185 12.5125C7.24193 11.5562 6.72036 10.3896 6.54788 9.14834C6.37539 7.90711 6.55909 6.64242 7.07759 5.50156C7.59608 4.3607 8.42803 3.39063 9.47654 2.70432C10.525 2.01801 11.747 1.6437 13 1.625C14.7369 1.64216 16.3962 2.34698 17.6145 3.58509C18.8328 4.82319 19.5108 6.49366 19.5 8.23063C19.5006 9.74588 18.9848 11.2161 18.0375 12.3988L13 19.5ZM13 3.25C11.6934 3.265 10.4461 3.79793 9.53207 4.73176C8.61805 5.66559 8.11197 6.92398 8.12498 8.23063C8.13042 9.42323 8.55949 10.5751 9.3356 11.4806L13 16.6725L16.7619 11.375C17.4769 10.4824 17.8692 9.3743 17.875 8.23063C17.888 6.92398 17.3819 5.66559 16.4679 4.73176C15.5539 3.79793 14.3066 3.265 13 3.25Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.9375C13.8975 8.9375 14.625 8.20996 14.625 7.3125C14.625 6.41504 13.8975 5.6875 13 5.6875C12.1025 5.6875 11.375 6.41504 11.375 7.3125C11.375 8.20996 12.1025 8.9375 13 8.9375Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9.75H21.125V11.375H22.75V22.75H3.25V11.375H4.875V9.75H3.25C2.81902 9.75 2.4057 9.92121 2.10095 10.226C1.7962 10.5307 1.625 10.944 1.625 11.375V22.75C1.625 23.181 1.7962 23.5943 2.10095 23.899C2.4057 24.2038 2.81902 24.375 3.25 24.375H22.75C23.181 24.375 23.5943 24.2038 23.899 23.899C24.2038 23.5943 24.375 23.181 24.375 22.75V11.375C24.375 10.944 24.2038 10.5307 23.899 10.226C23.5943 9.92121 23.181 9.75 22.75 9.75Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMap);
export default __webpack_public_path__ + "static/media/navbar-map.912d327c.svg";
export { ForwardRef as ReactComponent };